const mediaItems = [
  {
    title: '《星辰大海》都市情感大剧热播中',
    tag: '榴莲视频 · 热播',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20cinematic%20scene%20with%20city%20skyline%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20atmosphere%2C%20professional%20film%20photography%2C%20contemporary%20Chinese%20drama%20aesthetic%2C%20soft%20focus%2C%20cinematic%20color%20grading%20with%20amber%20tones%2C%20no%20text%20no%20people&width=800&height=500&seq=media-card-01&orientation=landscape',
    desc: '都市白领的奋斗与爱情，全网播放量突破5亿',
  },
  {
    title: '《长安夜未央》古装史诗震撼完结',
    tag: '红杏视频 · 完结',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20architecture%20in%20golden%20sunset%20light%2C%20historical%20drama%20cinematic%20scene%2C%20traditional%20Chinese%20rooftops%20with%20warm%20ambient%20glow%2C%20epic%20scale%2C%20professional%20film%20photography%2C%20rich%20cultural%20atmosphere%2C%20no%20text%20no%20people&width=800&height=500&seq=media-card-02&orientation=landscape',
    desc: '宫廷权谋巅峰之作，大结局催泪收官引热议',
  },
  {
    title: '《极速追击》好莱坞动作巨制上线',
    tag: '院线大片 · 高清',
    cover: 'https://readdy.ai/api/search-image?query=High%20speed%20car%20chase%20cinematic%20scene%20with%20dramatic%20lighting%2C%20action%20movie%20aesthetic%2C%20urban%20night%20setting%20with%20warm%20street%20lights%2C%20professional%20Hollywood%20style%20photography%2C%20intense%20atmosphere%2C%20dynamic%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=media-card-03&orientation=landscape',
    desc: '飙车枪战全程高能，4K画质极致视听享受',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            精选内容
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            精彩推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频精选热门影视内容，为你推荐不容错过的精彩佳作
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                </div>
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                  {item.tag}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 font-heading">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}